import * as React from "react";
import Image from "../../../ui-components/Image";
import { useTheme } from "@mui/material/styles";
import { Box, Typography, TextField, InputAdornment } from "@mui/material";

export default function Enumerate({ question, onAnswer = () => {} }) {
	const theme = useTheme();
	const [answer, setAnswer] = React.useState("");

	React.useEffect(() => {
		// reset proceed button
		setAnswer("");
	}, [question]);

	const handleSetAnswer = (e) => {
		setAnswer(e.target.value);
		let canProceed = false;
		if (e.target.value !== "") {
			canProceed = true;
		}
		onAnswer({
			canProceed,
			answer: e.target.value,
		});
	};

	return (
		<React.Fragment>
			<Box
				sx={{
					width: "100%",
					background: "white",
					pb: 2,
					pt: 1,
					px: 1,
				}}
				className="image-container"
			>
				<Image src={question.questionImage} />
			</Box>
			<Box
				className="choices-container"
				sx={{ pt: 2, px: { xs: 5, sm: 10 }, pb: 5 }}
			>
				<Typography
					sx={{ color: theme.palette.primary.main, mb: 1 }}
					variant="h6"
				>
					Answer:
				</Typography>
				<TextField
					type="number"
					value={answer}
					onChange={handleSetAnswer}
					fullWidth
					variant="standard"
					inputProps={{ style: { fontSize: "1.5rem" } }}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								{question.textBoxPrefix || ""}
							</InputAdornment>
						),
					}}
				/>
			</Box>
		</React.Fragment>
	);
}
